import React from 'react';
import { useHistory } from 'react-router-dom';

import EmptyList from 'components/EmptyList';
import List from 'components/List';
import ListItem from 'components/List/ListItem';
import useStoreTranslation from 'hooks/useStoreTranslation';
import { DashboardReportPeriod } from 'models/dashboardReports';

import { Info, DateTitle, IconImgDownload } from '../styles';

interface Props {
  data?: DashboardReportPeriod[];
}

const DashboardReportList = ({ data }: Props) => {
  const history = useHistory();
  const { t } = useStoreTranslation();

  const handleReportList = (values: any, dateTitle: string) => {
    history.push('/dashboardReports/reportDetail', { values, dateTitle });
  };

  return (
    <>
      {data?.length ? (
        <List>
          {data.map((item: DashboardReportPeriod, index) => (
            <ListItem key={index} onClick={() => handleReportList(item.values, `${item.month} de ${item.year}`)}>
              <Info>
                <DateTitle>{`${item.month} de ${item.year}`}</DateTitle>
                <IconImgDownload src="/images/download.svg" />
              </Info>
            </ListItem>
          ))}
        </List>
      ) : (
        <EmptyList
          grey
          description={t('dashboard.dashboardReports.emptyData')}
          image="/images/empty-awaiting-requests.svg"
          backgroundImage="/images/group-3.svg"
        />
      )}
    </>
  );
};

export default DashboardReportList;
